import SEO from "@/components/SEO";
import { ShieldCheck, Download, ExternalLink } from "lucide-react";

export default function CertificatQualiopi() {
  return (
    <>
      <SEO
        title="Certificat Qualiopi"
        description="Certificat Qualiopi n° 639711-3 de YAFORMIS, délivré par CERTIFOPAC au titre des actions de formation. Valide du 14/08/2024 au 13/08/2027."
        path="/certificat-qualiopi"
      />
      <section className="bg-white py-14 md:py-20" data-testid="certificat-page">
        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <div className="overline">Certification qualité</div>
          <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl mt-3 leading-tight text-brand-ink">
            Certificat Qualiopi
          </h1>
          <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl">
            YAFORMIS est certifié <strong className="text-brand-ink">Qualiopi</strong> au titre de la catégorie « Actions de formation ». Cette certification atteste de la qualité de nos prestations de formation professionnelle et permet le financement de nos formations par les fonds publics et mutualisés (CPF, OPCO).
          </p>

          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-px bg-brand-line border border-brand-line" data-testid="certificat-facts">
            <Fact label="Certificat" value="n° 639711-3" />
            <Fact label="Organisme" value="CERTIFOPAC" />
            <Fact label="Délivré le" value="14/08/2024" />
            <Fact label="Valide jusqu'au" value="13/08/2027" />
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="/certificat-qualiopi.pdf"
              download
              className="btn-cta"
              data-testid="certificat-download"
            >
              Télécharger le certificat (PDF)
              <Download className="w-5 h-5" />
            </a>
            <a
              href="/certificat-qualiopi.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost"
              data-testid="certificat-open"
            >
              Ouvrir dans un nouvel onglet
              <ExternalLink className="w-5 h-5" />
            </a>
          </div>

          <div className="mt-10 border border-brand-line bg-brand-surface p-2" data-testid="certificat-viewer">
            <img
              src="/certificat-qualiopi.png"
              alt="Certificat Qualiopi n° 639711-3 délivré à YAFORMIS par CERTIFOPAC — catégorie Actions de formation, valide du 14/08/2024 au 13/08/2027"
              className="w-full h-auto bg-white"
              data-testid="certificat-image"
            />
          </div>

          <p className="mt-6 flex items-start gap-2 text-sm text-slate-500 leading-relaxed">
            <ShieldCheck className="w-4 h-4 text-brand-blue shrink-0 mt-0.5" />
            La certification qualité a été délivrée au titre de la catégorie d'actions suivante : L.6313-1 – 1° Actions de formation. Vous pouvez vérifier la validité de ce certificat auprès de CERTIFOPAC (contact@certifopac.fr).
          </p>
        </div>
      </section>
    </>
  );
}

function Fact({ label, value }) {
  return (
    <div className="bg-white p-4 md:p-5">
      <div className="text-[11px] uppercase tracking-wider font-semibold text-slate-500">{label}</div>
      <div className="font-heading font-bold text-base md:text-lg mt-1 text-brand-ink leading-tight">{value}</div>
    </div>
  );
}
